/**
 * Pure tree-walking helpers extracted from `AgentTreeView.tsx`. They live
 * here (not co-located with the component) so the component file only
 * exports components — required by `react-refresh/only-export-components`
 * for HMR to work without forcing a full reload on style/markup edits.
 */
import type { AgentToolInfoDto, AgentTreeNodeDto } from '@inference.engine/api-client/web';

export function collectAllTools(node: AgentTreeNodeDto): AgentToolInfoDto[] {
  return [...node.tools, ...node.children.flatMap(collectAllTools)];
}
